import styled from "styled-components";
import Button from "./components/Button.js";
export default styled(Button)``;
